import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 spotlight-gold opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14 max-w-3xl">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Müşteri Yorumları
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-balance">
            <span className="text-gradient-silver">Eskişehir'in</span>{" "}
            <span className="text-gradient-gold">güvenilir adresi.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.slice(0, 6).map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative glass rounded-2xl p-7 card-lift hover:border-gold/40"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold/20" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 text-gold fill-gold" />
                ))}
              </div>
              <p className="text-white/80 text-sm leading-relaxed mb-6">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                <div className="w-10 h-10 rounded-full gradient-gold flex items-center justify-center font-bold text-black text-sm">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">
                    {t.name}
                  </div>
                  <div className="text-xs text-white/55">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
